import React from "react";
import { connect } from "react-redux";

import { getTransaction, getMoreTransaction } from '../../../actions/transactionActions';
import { getPayOutList } from '../../../actions/payOutActions';
import { getCurrentUser } from '../../../actions/session';
import { getHeader } from "../../../helper";

import IndividualContent from './IndividualContent';

class Balance extends React.Component {

    componentWillMount() {
        const { dispatch, session } = this.props;

        dispatch(getTransaction());
        dispatch(getPayOutList());

        dispatch(getCurrentUser(session.token, () => console.log('ok!'), true));
    }

    getTransactions(type) {
        const { dispatch } = this.props;

        dispatch(getTransaction())
    }

    handleMoreRecords(nextPage) {
        if(!nextPage) return false;

        const { dispatch } = this.props;
        let headers = getHeader()

        dispatch(getMoreTransaction(nextPage, {
            params: {},
            headers
        }));
    }

    render() {

        const {
            transactions,
            session,
            withdrawMoney,
            cashInUserOpen,
            payOutList,
        } = this.props;

        const { isFetchingMore } = transactions;
        const moreRecords = transactions.data.next || null;
        const { currentUser } = session;

        return(
            <div className="right-content native-scroll right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-balance menu-content-item tab-parent screen-bottom-block">
                    
                        <div className="rounded-white-block"> 

                            <div className="white-block-content">
                                <IndividualContent
                                    transactions={transactions}
                                    currentUser={currentUser}
                                    payOutList={payOutList}
                                    withdrawMoney={withdrawMoney}
                                    showBalancePopup2={cashInUserOpen}
                                />
                            </div>

                        </div>
                        {
                            moreRecords ?
                            <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                                <button
                                    className={isFetchingMore ? 'disabled' : ''}
                                    onClick={() => this.handleMoreRecords(moreRecords)}>
                                    {isFetchingMore ? 'Загружается...' : 'Загрузить еще'}
                                </button>
                            </div>
                            : ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};
  
export default connect(mapStateToProps)(Balance);


// WEBPACK FOOTER //
// ./src/components/Account/Balance/index.js